import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import './QrCodeModal.scss';
import { RootState } from '../../../../store/rootState';


interface QrCodeModalProps {
  visible: boolean;
  onClose: () => void;
}

const QrCodeModal: React.FC<QrCodeModalProps> = ({
  visible,
  onClose,
}) => {
  const userInfo = useSelector((state: RootState) => state.auth.userInfo);
  const [isAnimating, setIsAnimating] = useState(false);
  const qrCodeUri = `data:image/png;base64,${userInfo?.qrCodeBytes || ''}`;

  useEffect(() => {
    if (visible) {
      setIsAnimating(true);
    }
  }, [visible]);

  const handleClose = () => {
    setIsAnimating(false);
    setTimeout(() => {
      onClose();
    }, 300);
  };

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  if (!visible) return null;

  return (
    <div 
      className={`qr-modal-overlay ${isAnimating ? 'active' : ''}`}
      onClick={handleOverlayClick}
    >
      <div className={`qr-modal-container ${isAnimating ? 'active' : ''}`}>
        <div className="qr-modal-content">
          <div className="background-decoration" />
          <div className="background-decoration-2" />
          
          <h2 className={`modal-title ${isAnimating ? 'active' : ''}`}>
            FIOFID
          </h2>

          <div className={`qr-container ${isAnimating ? 'active' : ''}`}>
            <div className="qr-image-wrapper">
              <img
                src={qrCodeUri}
                alt="QR Code"
                className="modal-qr-image"
              />
            </div>
          </div>

          <div className={`modal-code-container ${isAnimating ? 'active' : ''}`}>
            <div className="code-wrapper">
              <span className="modal-code-value">
                {userInfo?.qrCodeValue || ''}
              </span>
            </div>
          </div>

          <div className={`button-container ${isAnimating ? 'active' : ''}`}>
            <button
              className="close-button"
              onClick={handleClose}
              aria-label="Close modal"
            >
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default QrCodeModal;